// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body[data-v-9d706070] {
  padding: 0px;
  flex-direction: column;
  align-items: center;
  min-width: 360px;
}
.body .preview[data-v-9d706070] {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 1000;
}
.body .preview .add-files[data-v-9d706070] {
  position: absolute;
  z-index: 500;
  background-color: #ffffff;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--modal-elem-color);
  font-size: 18px;
  border: 1px dashed #0097D3;
  opacity: 0.9;
  transition: all 0.6s;
}
.body .preview .preview-empty[data-v-9d706070] {
  height: 60px;
  width: 100%;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--pub-footer-active);
  font-size: 18px;
  margin-bottom: 5px;
}
.body .preview .preview-empty-danger[data-v-9d706070] {
  border: 1px solid var(--elem-red-color);
  color: var(--elem-red-color);
}
.body .preview .preview-images[data-v-9d706070] {
  max-height: calc(var(--vh) * 90 - 350px);
  overflow-y: auto;
  text-align: center;
  z-index: 100;
}
.body .preview .preview-images .preview-image[data-v-9d706070] {
  position: relative;
}
.body .preview .preview-images .preview-image .preview-image-hover[data-v-9d706070] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 5px;
}
.body .preview .preview-images .preview-image .preview-image-hover .delete-btn-img[data-v-9d706070] {
  font-size: 20px;
  color: white;
  margin-top: 3px;
  margin-right: 3px;
  cursor: pointer;
  text-align: right;
}
.body .preview .preview-images .preview-image .preview-image-hover .delete-btn-img[data-v-9d706070]:hover {
  opacity: 1;
}
.body .preview .preview-images .preview-image img[data-v-9d706070] {
  width: 99%;
  border-radius: 5px;
  margin: 5px 0px;
  max-width: 300px;
  max-height: 300px;
  object-fit: contain;
}
.body .preview .preview-images .preview-image .lock-icon[data-v-9d706070] {
  position: absolute;
  color: var(--bg-color);
  background-color: var(--activity-line-bgcolor);
  border-radius: 50%;
  width: 1.5em;
  top: 1.1em;
  left: 0.8em;
}
.body .preview .preview-images .preview-image .lock-icon i[data-v-9d706070] {
  color: whitesmoke;
  padding-bottom: 3px;
}
.body .preview .preview-images-scroll[data-v-9d706070] {
  width: calc(100% + 15px);
  margin-right: -15px;
}
.body .preview .preview-files[data-v-9d706070] {
  max-height: calc(var(--vh) * 90 - 350px);
  overflow-y: auto;
  width: var(--preview-width);
  pointer-events: inherit;
}
.body .preview .preview-files.groupped[data-v-9d706070] {
  width: auto;
}
.body .preview .preview-files .preview-file[data-v-9d706070] {
  display: flex;
  padding: 10px;
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.body .preview .preview-files .preview-file[data-v-9d706070]:hover {
  opacity: 0.7;
}
.body .preview .preview-files .preview-file .preview-file-icon[data-v-9d706070] {
  height: 40px;
  width: 40px;
  border-radius: 20px;
  background-color: var(--modal-elem-color);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: white;
  font-size: 20px;
  flex-shrink: 0;
}
.body .preview .preview-files .preview-file .icon-image[data-v-9d706070] {
  height: 40px;
  width: 40px;
  overflow: hidden;
  margin-right: 10px;
  border-radius: 4px;
}
.body .preview .preview-files .preview-file .icon-image img[data-v-9d706070] {
  width: 100%;
  height: 100%;
}
.body .preview .preview-files .preview-file .icon-image .video-btn-wrapper[data-v-9d706070] {
  position: absolute;
  display: flex;
  width: 40px;
  height: 40px;
  top: 10px;
  left: 10px;
}
.body .preview .preview-files .preview-file .icon-image .video-btn-wrapper .video-btn[data-v-9d706070] {
  position: relative;
  width: 24px;
  height: 24px;
  display: inline-flex;
  background-color: #76a7f3;
  border-radius: 50%;
  margin: auto;
}
.body .preview .preview-files .preview-file .icon-image .video-btn-wrapper .video-btn i[data-v-9d706070] {
  color: #fff;
  margin: auto;
  font-size: 12px;
  padding-left: 2px;
}
.body .preview .preview-files .preview-file .preview-file-name[data-v-9d706070] {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.body .preview .preview-files .preview-file .preview-file-size[data-v-9d706070] {
  font-size: 13px;
  color: #aaaaaa;
  margin-top: 2px;
}
.body .preview .preview-files .preview-file .delete-btn-img[data-v-9d706070] {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.5;
  color: white;
  cursor: pointer;
}
.body .preview .preview-files .preview-file .delete-btn-img[data-v-9d706070]:hover {
  opacity: 1;
}
.body .preview .preview-files .preview-file .delete-btn-img i[data-v-9d706070] {
  border-radius: 12px;
  background-color: #666666c4;
}
.body .preview .preview-files .preview-files-group[data-v-9d706070] {
  display: grid;
  grid-template-columns: auto auto;
}
.body .preview .preview-files .preview-files-group .preview-image-hover[data-v-9d706070] {
  position: relative;
  top: -2px;
  right: 1px;
}
.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070] {
  padding: 1px;
  margin: 0;
  width: 140px;
  height: 140px;
}
.body .preview .preview-files .preview-files-group .preview-file img[data-v-9d706070] {
  max-width: 100%;
  object-fit: contain;
  margin: 0 auto;
}
.body .preview .preview-files .preview-files-group .preview-file img[data-v-9d706070]:hover {
  transition: all 0.3s;
}
.body .preview .preview-files .preview-files-group .preview-file img:hover .delete-btn-img[data-v-9d706070] {
  opacity: 0.85;
}
.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070]:first-child {
  border-top: 1px solid var(--btn-bghover);
}
.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070]:nth-child(odd) {
  border-top: 1px solid var(--btn-bghover);
  border-left: 1px solid var(--btn-bghover);
  border-right: 1px solid var(--btn-bghover);
}
.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070]:nth-child(even) {
  border-top: 1px solid var(--btn-bghover);
  border-right: 1px solid var(--btn-bghover);
}
.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070]:last-child {
  border-right: 1px solid var(--btn-bghover);
  border-bottom: 1px solid var(--btn-bghover);
}
.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070]:hover {
  transition: all 0.3s;
}
.body .preview .preview-files .preview-files-group .delete-btn-img[data-v-9d706070] {
  opacity: 0.7 !important;
}
.body .preview .preview-files .preview-files-group .delete-btn-img[data-v-9d706070]:hover {
  opacity: 1 !important;
}
.body .preview .preview-files .preview-files-group .icon-image[data-v-9d706070] {
  width: 100%;
  height: 100%;
  margin-right: 0;
}
.body .preview .preview-files .preview-files-group .icon-image img[data-v-9d706070] {
  height: inherit;
}
.body .preview .preview-image-hover[data-v-9d706070] {
  position: absolute;
  font-size: large;
  top: 0px;
  right: 20px;
  opacity: 0.5;
}
.body .preview .preview-image-hover[data-v-9d706070]:hover {
  opacity: 1;
}
.body .preview .preview-image-hover .delete-btn-img[data-v-9d706070] {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0.5;
  color: white;
  font-size: 20px;
  cursor: pointer;
}
.body .preview .preview-image-hover .delete-btn-img[data-v-9d706070]:hover {
  opacity: 1;
}
.body .preview .preview-image-hover .delete-btn-img i[data-v-9d706070] {
  border-radius: 12px;
  background-color: #666666c4;
}
.body .preview .upload-progress[data-v-9d706070] {
  position: absolute;
  top: 34%;
  left: 45%;
}
.body .custom-textarea[data-v-9d706070] {
  display: block;
  width: 90%;
  font-size: 16px;
  border: none;
  border-bottom: 1px solid #cccccc;
  outline: none;
  height: auto;
  margin-top: 8px;
}
.body .custom-textarea[data-v-9d706070]::placeholder {
  color: #ccc !important;
  opacity: 1;
}
.body .custom-textarea[data-v-9d706070]:-ms-input-placeholder {
  color: #ccc !important;
}
.body .custom-textarea[data-v-9d706070]::-ms-input-placeholder {
  color: #ccc !important;
}
.body .custom-textarea[data-v-9d706070]:focus {
  border-bottom: 1px solid #0097D3;
  color: #000;
}
.body .focus[data-v-9d706070] {
  border-bottom: 1px solid #0097D3;
  color: #000;
}
.body .scroll[data-v-9d706070] {
  margin-left: -15px;
}
.image-scroll[data-v-9d706070] {
  padding-right: 5px;
}
.no-pointer-events[data-v-9d706070] {
  pointer-events: none;
}
.group-files[data-v-9d706070] {
  display: flex;
  align-items: end;
  width: 90%;
  height: 3em;
}
.group-files label.custom-checkbox[data-v-9d706070] {
  padding-left: 28px;
}
.group-files label.custom-checkbox i[data-v-9d706070] {
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/LoaderFiles.vue"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,4BAA4B;AAC9B;AACA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;AAC5C;AACA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;AACA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,cAAc;EACd,UAAU;EACV,eAAe;EACf,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB","sourcesContent":[".body[data-v-9d706070] {\n  padding: 0px;\n  flex-direction: column;\n  align-items: center;\n  min-width: 360px;\n}\n.body .preview[data-v-9d706070] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  z-index: 1000;\n}\n.body .preview .add-files[data-v-9d706070] {\n  position: absolute;\n  z-index: 500;\n  background-color: #ffffff;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--modal-elem-color);\n  font-size: 18px;\n  border: 1px dashed #0097D3;\n  opacity: 0.9;\n  transition: all 0.6s;\n}\n.body .preview .preview-empty[data-v-9d706070] {\n  height: 60px;\n  width: 100%;\n  border: 1px solid transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--pub-footer-active);\n  font-size: 18px;\n  margin-bottom: 5px;\n}\n.body .preview .preview-empty-danger[data-v-9d706070] {\n  border: 1px solid var(--elem-red-color);\n  color: var(--elem-red-color);\n}\n.body .preview .preview-images[data-v-9d706070] {\n  max-height: calc(var(--vh) * 90 - 350px);\n  overflow-y: auto;\n  text-align: center;\n  z-index: 100;\n}\n.body .preview .preview-images .preview-image[data-v-9d706070] {\n  position: relative;\n}\n.body .preview .preview-images .preview-image .preview-image-hover[data-v-9d706070] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border-radius: 5px;\n}\n.body .preview .preview-images .preview-image .preview-image-hover .delete-btn-img[data-v-9d706070] {\n  font-size: 20px;\n  color: white;\n  margin-top: 3px;\n  margin-right: 3px;\n  cursor: pointer;\n  text-align: right;\n}\n.body .preview .preview-images .preview-image .preview-image-hover .delete-btn-img[data-v-9d706070]:hover {\n  opacity: 1;\n}\n.body .preview .preview-images .preview-image img[data-v-9d706070] {\n  width: 99%;\n  border-radius: 5px;\n  margin: 5px 0px;\n  max-width: 300px;\n  max-height: 300px;\n  object-fit: contain;\n}\n.body .preview .preview-images .preview-image .lock-icon[data-v-9d706070] {\n  position: absolute;\n  color: var(--bg-color);\n  background-color: var(--activity-line-bgcolor);\n  border-radius: 50%;\n  width: 1.5em;\n  top: 1.1em;\n  left: 0.8em;\n}\n.body .preview .preview-images .preview-image .lock-icon i[data-v-9d706070] {\n  color: whitesmoke;\n  padding-bottom: 3px;\n}\n.body .preview .preview-images-scroll[data-v-9d706070] {\n  width: calc(100% + 15px);\n  margin-right: -15px;\n}\n.body .preview .preview-files[data-v-9d706070] {\n  max-height: calc(var(--vh) * 90 - 350px);\n  overflow-y: auto;\n  width: var(--preview-width);\n  pointer-events: inherit;\n}\n.body .preview .preview-files.groupped[data-v-9d706070] {\n  width: auto;\n}\n.body .preview .preview-files .preview-file[data-v-9d706070] {\n  display: flex;\n  padding: 10px;\n  width: 100%;\n  margin: 0 auto;\n  position: relative;\n}\n.body .preview .preview-files .preview-file[data-v-9d706070]:hover {\n  opacity: 0.7;\n}\n.body .preview .preview-files .preview-file .preview-file-icon[data-v-9d706070] {\n  height: 40px;\n  width: 40px;\n  border-radius: 20px;\n  background-color: var(--modal-elem-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 10px;\n  color: white;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n.body .preview .preview-files .preview-file .icon-image[data-v-9d706070] {\n  height: 40px;\n  width: 40px;\n  overflow: hidden;\n  margin-right: 10px;\n  border-radius: 4px;\n}\n.body .preview .preview-files .preview-file .icon-image img[data-v-9d706070] {\n  width: 100%;\n  height: 100%;\n}\n.body .preview .preview-files .preview-file .icon-image .video-btn-wrapper[data-v-9d706070] {\n  position: absolute;\n  display: flex;\n  width: 40px;\n  height: 40px;\n  top: 10px;\n  left: 10px;\n}\n.body .preview .preview-files .preview-file .icon-image .video-btn-wrapper .video-btn[data-v-9d706070] {\n  position: relative;\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  background-color: #76a7f3;\n  border-radius: 50%;\n  margin: auto;\n}\n.body .preview .preview-files .preview-file .icon-image .video-btn-wrapper .video-btn i[data-v-9d706070] {\n  color: #fff;\n  margin: auto;\n  font-size: 12px;\n  padding-left: 2px;\n}\n.body .preview .preview-files .preview-file .preview-file-name[data-v-9d706070] {\n  max-width: 250px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.body .preview .preview-files .preview-file .preview-file-size[data-v-9d706070] {\n  font-size: 13px;\n  color: #aaaaaa;\n  margin-top: 2px;\n}\n.body .preview .preview-files .preview-file .delete-btn-img[data-v-9d706070] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  opacity: 0.5;\n  color: white;\n  cursor: pointer;\n}\n.body .preview .preview-files .preview-file .delete-btn-img[data-v-9d706070]:hover {\n  opacity: 1;\n}\n.body .preview .preview-files .preview-file .delete-btn-img i[data-v-9d706070] {\n  border-radius: 12px;\n  background-color: #666666c4;\n}\n.body .preview .preview-files .preview-files-group[data-v-9d706070] {\n  display: grid;\n  grid-template-columns: auto auto;\n}\n.body .preview .preview-files .preview-files-group .preview-image-hover[data-v-9d706070] {\n  position: relative;\n  top: -2px;\n  right: 1px;\n}\n.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070] {\n  padding: 1px;\n  margin: 0;\n  width: 140px;\n  height: 140px;\n}\n.body .preview .preview-files .preview-files-group .preview-file img[data-v-9d706070] {\n  max-width: 100%;\n  object-fit: contain;\n  margin: 0 auto;\n}\n.body .preview .preview-files .preview-files-group .preview-file img[data-v-9d706070]:hover {\n  transition: all 0.3s;\n}\n.body .preview .preview-files .preview-files-group .preview-file img:hover .delete-btn-img[data-v-9d706070] {\n  opacity: 0.85;\n}\n.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070]:first-child {\n  border-top: 1px solid var(--btn-bghover);\n}\n.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070]:nth-child(odd) {\n  border-top: 1px solid var(--btn-bghover);\n  border-left: 1px solid var(--btn-bghover);\n  border-right: 1px solid var(--btn-bghover);\n}\n.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070]:nth-child(even) {\n  border-top: 1px solid var(--btn-bghover);\n  border-right: 1px solid var(--btn-bghover);\n}\n.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070]:last-child {\n  border-right: 1px solid var(--btn-bghover);\n  border-bottom: 1px solid var(--btn-bghover);\n}\n.body .preview .preview-files .preview-files-group .preview-file[data-v-9d706070]:hover {\n  transition: all 0.3s;\n}\n.body .preview .preview-files .preview-files-group .delete-btn-img[data-v-9d706070] {\n  opacity: 0.7 !important;\n}\n.body .preview .preview-files .preview-files-group .delete-btn-img[data-v-9d706070]:hover {\n  opacity: 1 !important;\n}\n.body .preview .preview-files .preview-files-group .icon-image[data-v-9d706070] {\n  width: 100%;\n  height: 100%;\n  margin-right: 0;\n}\n.body .preview .preview-files .preview-files-group .icon-image img[data-v-9d706070] {\n  height: inherit;\n}\n.body .preview .preview-image-hover[data-v-9d706070] {\n  position: absolute;\n  font-size: large;\n  top: 0px;\n  right: 20px;\n  opacity: 0.5;\n}\n.body .preview .preview-image-hover[data-v-9d706070]:hover {\n  opacity: 1;\n}\n.body .preview .preview-image-hover .delete-btn-img[data-v-9d706070] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  opacity: 0.5;\n  color: white;\n  font-size: 20px;\n  cursor: pointer;\n}\n.body .preview .preview-image-hover .delete-btn-img[data-v-9d706070]:hover {\n  opacity: 1;\n}\n.body .preview .preview-image-hover .delete-btn-img i[data-v-9d706070] {\n  border-radius: 12px;\n  background-color: #666666c4;\n}\n.body .preview .upload-progress[data-v-9d706070] {\n  position: absolute;\n  top: 34%;\n  left: 45%;\n}\n.body .custom-textarea[data-v-9d706070] {\n  display: block;\n  width: 90%;\n  font-size: 16px;\n  border: none;\n  border-bottom: 1px solid #cccccc;\n  outline: none;\n  height: auto;\n  margin-top: 8px;\n}\n.body .custom-textarea[data-v-9d706070]::placeholder {\n  color: #ccc !important;\n  opacity: 1;\n}\n.body .custom-textarea[data-v-9d706070]:-ms-input-placeholder {\n  color: #ccc !important;\n}\n.body .custom-textarea[data-v-9d706070]::-ms-input-placeholder {\n  color: #ccc !important;\n}\n.body .custom-textarea[data-v-9d706070]:focus {\n  border-bottom: 1px solid #0097D3;\n  color: #000;\n}\n.body .focus[data-v-9d706070] {\n  border-bottom: 1px solid #0097D3;\n  color: #000;\n}\n.body .scroll[data-v-9d706070] {\n  margin-left: -15px;\n}\n.image-scroll[data-v-9d706070] {\n  padding-right: 5px;\n}\n.no-pointer-events[data-v-9d706070] {\n  pointer-events: none;\n}\n.group-files[data-v-9d706070] {\n  display: flex;\n  align-items: end;\n  width: 90%;\n  height: 3em;\n}\n.group-files label.custom-checkbox[data-v-9d706070] {\n  padding-left: 28px;\n}\n.group-files label.custom-checkbox i[data-v-9d706070] {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
